import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" ANGEL ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" LEAGUE ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ART ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" NFT ")

import {AgBoxS, AgIconS, AgText} from '@/components/ag'

export default /*#__PURE__*/_defineComponent({
  props: {
  name: {type: String},
},
  setup(__props) {

const props = __props




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), {
    class: "logo-wrapper",
    css: {display:'flex', pd:4}
  }, {
    default: _withCtx(() => [
      (__props.name === 'art')
        ? (_openBlock(), _createBlock(_unref(AgIconS), {
            key: 0,
            name: "agArtLogo",
            css: {width:25, height: 25}
          }))
        : (__props.name === 'nft')
          ? (_openBlock(), _createBlock(_unref(AgIconS), {
              key: 1,
              name: "agNftLogo",
              css: {width:25, height: 25}
            }))
          : (_openBlock(), _createBlock(_unref(AgIconS), {
              key: 2,
              name: "agDefaultLogo",
              css: {width:25, height: 25}
            })),
      _createVNode(_unref(AgBoxS), { css: {color: '#04004F', fontSize: 18, lineHeight: 1} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgText), { css: {fontSize: 18, fontWeight: 600, letterSpacing: 1.2} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["css"]),
          _createVNode(_unref(AgText), { css: {fontSize: 18, ml:-7} }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          (__props.name==='art')
            ? (_openBlock(), _createBlock(_unref(AgText), {
                key: 0,
                css: {fontSize: 18, color: '#875CFF', fontWeight: 600, ml:-4}
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : (__props.name==='nft')
              ? (_openBlock(), _createBlock(_unref(AgText), {
                  key: 1,
                  css: {fontSize: 18, color: 'blue1', fontWeight: 600, ml:-4}
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})